import { Button, Typography } from "@mui/material";
import React from "react";
import { PhotoProvider, PhotoView } from "react-photo-view";
import zScore from "./Z-Score-vert.png";
const GraphComponent = ({ graph }) => {
  return (
    <div className="masking-z-score-div">
      <div className="masking-z-score-content">
        <div className="masking-image-container">
          <PhotoProvider>
            <PhotoView src={"data:image/jpeg;base64," + graph.image}>
              <img
                alt="masking"
                className="masking-z-score-img"
                src={"data:image/jpeg;base64," + graph.image}
              />
            </PhotoView>
          </PhotoProvider>
        </div>
        {/* <div className="z-score-legend-container">
          <PhotoProvider>
            <PhotoView src={zScore}>
              <img className="z-score-graph-img" alt="z-score" src={zScore} />
            </PhotoView>
          </PhotoProvider>
        </div> */}
      </div>
      {/* <div className="masking-z-score-footer">
        <Typography>{graph.name}</Typography>
        <Button className="masking-z-score-footer-button" variant="contained" href={graph.tiff_url}>
          download as tiff
        </Button>
      </div> */}
    </div>
  );
};

export default GraphComponent;
